import { API_DOMAIN } from '../constants';
import HttpClient from '../helpers/HttpClient';
//const API_DOMAIN = "https://capacitamos.com/online"

export const openSystemBrowser = (url) => {
    window.open(url, "_blank")
}

export const getPathCourseResource = async(path) => {
    return `${API_DOMAIN}/contents/${path}`
}

export const getBinaryContent = async(path) => {

    const request = await HttpClient().post("/file",{
        file: path
    },
    {
        responseType: 'blob',
        timeout: 50000,
    });
    return request.data
    //return await window.electron.ipcRenderer.invoke('getBinaryContent', path);
}

export const getMachineId = async() => {
    //return await window.electron.ipcRenderer.invoke('getMachineId');
}

export const deleteSerialFiles = async() => {
    //return await window.electron.ipcRenderer.invoke('deleteSerialFiles');
}

export const readSerialFiles = async(pin) => {
    //return await window.electron.ipcRenderer.invoke('readSerialFiles', pin);
}

export const isInternetAvailable = async(domain) => {
    //return await window.electron.ipcRenderer.invoke('isInternetAvailable', domain);
}

export const axiosNativePost = async(path, payload) => {
    //return await window.electron.ipcRenderer.invoke('axiosNativePost', {path: path, payload:payload});
}